import React from "react";
import { Link } from "react-router-dom";
import "./Item.css";

export const Item = ({
  id,
  title,
  pictureUrl,
  category,
  description,
  forms,
}) => {

  return (
    <div className="card cardItem w-1/5 h-92 m-auto bg-base-100 shadow-2xl mb-8 sm:w-4/5 md:w-2/5 xl:w-1/5 m-8 ">
      <figure className="cardImage	">
        <img src={pictureUrl} alt={title} className="h-full w-full	" />
      </figure>
      <div className="card-body ">
        <h2 className="card-title m-auto xl:h-20">{title}</h2>
        <label htmlFor="my-modal" className="btn modal-button xl:w-4/5 m-auto">
          Ver Descripción
        </label>

        <input type="checkbox" id="my-modal" className="modal-toggle" />
        <div className="modal">
          <div className="modal-box">
            <h3 className="font-bold text-lg">Descripción:</h3>
            <p className="py-4">{description}</p>
            <div className="modal-action">
              <label htmlFor="my-modal" className="btn">
                cerrar
              </label>
            </div>
          </div>
        </div>
        <div className="card-actions flex justify-center ">
          <Link className="btn btn-detalle" to={`/Productos/${id}`}>
            Detalles
          </Link>
        </div>
      </div>
    </div>
  );
};
